export default __webpack_public_path__ + "static/media/96426E39-F260-4C0D-9EF9-3C2E08A82B82_1_105_c.acf11bad.jpeg";